<template>
  <div class="task-details chain-details">
    <Modal
      :active="active"
      name="ChainTaskDetailsModal"
      :closable="true"
      class="task-details__modal chain-details__modal"
      @close="$emit('close')"
    >
      <div class="task-details__img" :style="{ 'background-image': `url(${images && images.desktop ? images.desktop : ''})` }">
        <div class="task-details__back" @click="$emit('close')">
          <Button
            variant="secondary"
            :size="$root.isMobile ? 'sm' : 'lg'"
            shape="circle"
            iconLeft="left"
            mobile
            @click="$emit('close')"
          ></Button>
        </div>
        <div v-if="currentState === 'inProgress'" class="task-details__menu">
          <Button
            variant="secondary"
            :size="$root.isMobile ? 'sm' : 'lg'"
            shape="circle"
            iconLeft="more-vertical"
            mobile
            id="menuButton1"
          ></Button>
          <Dropdown
            triggerId="menuButton1"
            placement="bottom"
            listeners="click"
            hide-overlay
            auto-width
          >
            <template slot="items">
              <div class="base-dropdown__item">
                <a class="base-dropdown__link" @click.prevent="onConfirmTaskCancel">
                  <Icon name="close" size="m" />
                  <span>Отказаться от выполнения</span>
                </a>
              </div>
            </template>
          </Dropdown>
        </div>
      </div>

      <div class="task-details__main" v-if="data">
        <div class="main__title text-left main__title-chain">
          {{ title }}
          <span class="main__title-links">{{ links ? links.length : 0 }}</span>
        </div>
        <div class="main__description text-left" v-html="subtitle || ''"></div>
        <div class="main__reward text-left">
          <div class="reward-card" :class="{ 'reward-card--reward-only': !hasRatingPoints() }">
            <div class="reward-card__title">Награда и очки</div>
            <div class="reward-card__value">
              <img :src="coin" width="24" height="24" /><span>{{ getTaskReward() }}</span>
            </div>
            <div v-if="hasRatingPoints()" class="reward-card__value" :class="{ 'value--grayscale': getCompletedTaskState() === 'checking' }">
              <img :src="point" width="24" height="24" /><span>{{ getTaskRatingPoints() }}</span>
            </div>
          </div>
          <div class="reward-card">
            <div class="reward-card__title">{{ isCompletedChain() ? 'Завершено' : 'Срок выполнения' }}</div>
            <div class="reward-card__value value--small">
              <span v-if="isCompletedChain()">{{ getFormattedDate() }}</span>
              <span v-else><span>до </span>{{ getFormattedDate() }}</span>
            </div>
          </div>
          <div class="reward-card">
            <div class="reward-card__title">Сложность и Активность</div>
            <div>
              <div class="reward-card__complexity" :class="getComplexityClass()">
                <img v-if="getTaskComplexity() === 'Новичок'" :src="complexityLow" alt="" />
                <img v-if="getTaskComplexity() === 'Любитель'" :src="complexityMedium" alt="" />
                <img v-if="getTaskComplexity() === 'Опытный'" :src="complexityHigh" alt="" />
                <img v-if="getTaskComplexity() === 'Мастер'" :src="complexityMaster" alt="" />
                <span>{{ getTaskComplexity() }}</span>
              </div>
            </div>
            <div class="reward-card__value">
              <div
                v-for="(icon, i) in disciplines"
                :key="i"
                class="value__activity"
              >
                <Icon :name="icon" size="xs" />
              </div>
            </div>
          </div>
        </div>
        <div class="main__tracker text-left" v-if="data && data.isTrackerNeeded">
          <Icon name="fitness-tracker" size="m" />Для выполнения потребуется трекер. <a :href="articleAboutTrackers" target="_blank">Что это?</a>
        </div>
        <div class="main__full-description text-left">
          <div class="main__subtitle">О цепочке</div>
          <div
            class="main__description"
            :class="{ 'description--collapsed': !showFullDescription }"
            v-html="description || ''"
          ></div>
          <button
            v-if="shouldShowExpandButton"
            class="description__expand-button"
            @click="toggleDescription"
          >
            <Icon :name="showFullDescription ? 'minus' : 'plus'" size="s" />
            {{ showFullDescription ? 'Показать меньше' : 'Показать больше' }}
          </button>
        </div>
        <div class="main__full-description text-left" v-if="links && links.length > 0">
          <div class="main__subtitle">Задания в цепочке</div>
          <div class="main__links">
            <TaskCard
              v-for="(link, index) in links" :key="link.participantExerciseChainLinkId || link.exerciseChainLinkId || link.exerciseId || `link-${index}`"
              class="main__link-card"
              :class="[getLinkStatusClass(link), { 'task--chain-only': link.isChainOnly }]"
              :stateLabels="stateLabels"
              :timeLabels="timeLabels"
              :styleLabels="styleLabels"
              :cost="getTaskRewardRange(link)"
              type="coins"
              :state="getLinkState(link)"
              :image="getLinkImage(link)"
              :title="getLinkTitle(link)"
              :subtitle="getLinkSubtitle(link)"
              :complexity="getLinkComplexity(link)"
              :disciplines="filterDisciplines(getLinkDisciplines(link))"
              :itemsTotal="getLinkItemsTotal(link)"
              :itemsDone="getLinkItemsDone(link)"
              :chainsCount="getLinkChainsCount(link)"
              :isSpecial="false"
              :isDaily="false"
              :isRepeat="false"
              :date="getLinkEndDate(link)"
              :action="getLinkAction(link, index)"
            />
          </div>
        </div>
      </div>
      <div class="task-details__action-container">
        <div
          class="task-details__action"
          :class="{
            'action--in-progress': currentState === 'inProgress',
            'action--completed': currentState === 'completed',
            'action--failed': currentState === 'failed',
            'action--checking': currentState === 'checking',
          }"
        >
          <Button
            v-if="currentState === 'Published' && !hasActiveChain && !hasInActiveLink"
            variant="primary"
            size="lg"
            text="Начать"
            :wide="true"
            mobile
            @click="$emit('start')"
          ></Button>
          <div v-if="currentState === 'Published' && hasActiveChain">
            <Button
              variant="secondary"
              size="lg"
              text="Начать"
              :wide="true"
              mobile
              :disabled="true"
            ></Button>
            <div class="action__progress action__progress--active-chain">
              Вы уже выполняете цепочку <span class="action__progress-link" @click="openActiveChain">{{ activeChainTitle }}</span>. Завершите или отмените её
            </div>
          </div>
          <div v-if="currentState === 'inProgress'">
            <div class="action__badges">
              <Badge
                v-if="badgeText"
                :state="currentState"
                :text="badgeText"
              />
              <Badge
                state="countdown"
                :text="countdownText"
              />
            </div>
            <div class="action__progress">Выполните все задачи вовремя</div>
          </div>
          <div v-if="currentState === 'completed'">
            <div class="action__badges">
              <Badge
                state="completed"
                text="Выполнено"
              />
            </div>
            <div class="action__progress">&nbsp;</div>
          </div>
          <div v-if="currentState === 'failed'">
            <div class="action__badges">
              <Badge
                state="failed"
                text="Вы не успели :("
              />
            </div>
            <div class="action__progress">Не все задачи были выполнены. <a href="#" @click.prevent="onSupport">Ошибка?</a></div>
          </div>
          <div v-if="currentState === 'checking'">
            <div class="action__badges">
              <Badge
                state="checking"
                text="Проверяется"
              />
            </div>
            <div class="action__progress">Ожидайте, обычно от 1 до 24 часов</div>
          </div>
        </div>
      </div>
    </Modal>
    <Modal
      name="task-cancel-confirm"
      state="warning"
      title="Отменить выполнение цепочки?"
      subtitle="Прогресс будет сброшен. Заработанные баллы и очки рейтинга сохранятся. Заново начать эту цепочку можно через 24 часа."
      :active="taskCancelModal"
      :noTransition="true"
      class="task-cancel-confirm"
      @close.prevent="taskCancelModal = false"
    >
      <Alert
        v-if="cancelError"
        :text="cancelError"
        state="error"
        no-action
      ></Alert>
      <div class="buttons-group">
        <div class="buttons-group__item">
          <Button
            variant="secondary"
            view="danger"
            size="lg"
            text="Да, отказаться"
            @click="onCancelTask"
            :loading="cancellingTask"
            :disabled="cancellingTask"
            wide
            mobile
          ></Button>
        </div>
        <div class="buttons-group__item buttons-group__item_first">
          <Button
            variant="secondary"
            size="lg"
            text="Нет, назад"
            @click="taskCancelModal = false"
            :loading="cancellingTask"
            :disabled="cancellingTask"
            wide
            mobile
          ></Button>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import TaskCard from '@sc-component-library/task-card/src/main';
import Alert from '@rr-component-library/alert/src/main';
import dayjs from 'dayjs';
import { getArticleByKey } from '@/assets/js/helpers';
import Dropdown from '@/components/Dropdown/Dropdown.vue';
import Coin from '@/assets/img/coin.svg';
import Point from '@/assets/img/point.svg';
import Low from '@/assets/img/low.svg';
import Medium from '@/assets/img/medium.svg';
import High from '@/assets/img/high.svg';
import Master from '@/assets/img/master.svg';
import Badge from '@/components/TaskDetailsModal/Badge.vue';

export default {
  name: 'ChainTaskDetailsModal',
  components: {
    TaskCard,
    Badge,
    Dropdown,
    Alert,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    state: {
      type: String,
      default: 'available',
    },
  },
  data() {
    return {
      images: null,
      title: null,
      subtitle: null,
      description: null,
      disciplines: [],
      links: [],
      badgeText: null,
      currentState: 'available',
      complexityLow: Low,
      complexityMedium: Medium,
      complexityHigh: High,
      complexityMaster: Master,
      coin: Coin,
      point: Point,
      disciplineCodes: [
        'walking', 'running', 'cycling', 'swimming', 'skiing', 'quiz', 'geolocation', 'invite', 'participation', 'uploadimage', 'partnerlink', 'registration', 'survey', 'fitness', 'strength', 'martialarts', 'playing', 'extreme', 'outdoor', 'dancing',
      ],
      countdownText: '',
      dateValue: null,
      isLongCountDown: false,
      countdownTimer: null,
      taskCancelModal: false,
      cancelError: null,
      cancellingTask: false,
      showFullDescription: false,
      stateLabels: {
        available: 'до ',
        inProgress: 'Выполняется',
        checking: 'Проверяется',
        completed: 'Выполнено',
        failed: 'Вы не успели :(',
      },
      styleLabels: {
        special: 'Особое задание',
        daily: 'Ежедневное',
        repeat: 'Многоразовое',
      },
      timeLabels: {
        days: 'д',
        hours: 'ч',
      },
    };
  },
  watch: {
    active(val) {
      if (val && this.data) {
        this.initModalData();
      } else if (!val) {
        // Очищаем таймер при закрытии модалки
        this.clearCountdown();
      }
    },
    data: {
      handler(val) {
        if (this.active && val) {
          this.initModalData();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapGetters('user', ['isAuthenticated', 'profile', 'isMobileApp']),
    ...mapGetters('settings', ['resources']),
    ...mapGetters('exercises', ['cancelStatus']),
    ...mapGetters('content', ['articles']),
    articleAboutTrackers() {
      const link = getArticleByKey(this.articles, 'key_2');
      return link || '#';
    },
    hasActiveChain() {
      return this.data && this.data.activeParticipantChainInfo && this.data.activeParticipantChainInfo.participantExerciseChainId;
    },
    activeChainTitle() {
      return this.data && this.data.activeParticipantChainInfo ? this.data.activeParticipantChainInfo.exerciseChainTitle : '';
    },
    hasInActiveLink() {
      if (!this.links || this.links.length === 0) return false;
      return this.links.some((link) => link.linkState === 'InActive');
    },

    shouldShowExpandButton() {
      if (!this.description) return false;
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = this.description;
      tempDiv.style.cssText = `
        position: absolute;
        visibility: hidden;
        width: 100%;
        font-size: 16px;
        line-height: 1.5;
        padding: 0;
        margin: 0;
        white-space: normal;
        word-wrap: break-word;
        max-width: 100%;
      `;
      document.body.appendChild(tempDiv);
      const height = tempDiv.offsetHeight;
      document.body.removeChild(tempDiv);
      return height > 96;
    },
  },
  methods: {
    ...mapActions('exercises', ['cancelTaskChain', 'sendSupport']),

    initModalData() {
      if (!this.data) {
        return;
      }

      this.images = this.data.images || null;
      this.title = this.data.title || '';
      this.subtitle = this.data.shortDescription || '';
      this.description = this.data.description || '';

      // Определяем состояние на основе данных
      if (this.data.participantExerciseChain) {
        // Есть данные участника - определяем состояние по ним
        const { state } = this.data.participantExerciseChain;
        if (state === 'Created') this.currentState = 'inProgress';
        else if (state === 'Completed') this.currentState = 'completed';
        else if (state === 'Rejected') this.currentState = 'failed';
        else if (state === 'AwaitingConfirmation') this.currentState = 'checking';
        else this.currentState = 'available';
      } else {
        // Нет данных участника - используем переданное состояние или по умолчанию
        this.currentState = this.state || 'available';
      }

      this.disciplines = this.getDisciplines();

      if (this.data.participantExerciseChain && this.data.participantExerciseChain.links) {
        this.links = this.data.participantExerciseChain.links;
      } else if (this.data.links) {
        this.links = this.data.links;
      } else {
        this.links = [];
      }

      this.badgeText = this.getBadgeText();

      // Запуск таймера
      this.startCountdown();
    },

    getLinkTitle(link) {
      if (link.exercise) {
        return link.exercise.title || '';
      }
      if (link.exerciseChainLink && link.exerciseChainLink.exercise) {
        return link.exerciseChainLink.exercise.title || '';
      }
      return '';
    },

    getLinkSubtitle(link) {
      if (link.exercise) {
        return link.exercise.shortDescription || '';
      }
      if (link.exerciseChainLink && link.exerciseChainLink.exercise) {
        return link.exerciseChainLink.exercise.shortDescription || '';
      }
      return '';
    },

    getLinkComplexity(link) {
      if (link.exercise) {
        return link.exercise.complexity || 1;
      }
      if (link.exerciseChainLink && link.exerciseChainLink.exercise) {
        return link.exerciseChainLink.exercise.complexity || 1;
      }
      return 1;
    },

    getLinkState(link) {
      if (link.linkState) {
        const state = link.linkState.toLowerCase();
        if (state === 'completed') return 'completed';
        if (state === 'rejected') return 'failed';
        if (state === 'awaitingconfirmation') return 'checking';
        if (state === 'inprogress') return 'inProgress';
        if (state === 'inactive') return 'available';
        if (state === 'created') return 'inProgress';
      }

      if (link.participantExerciseState) {
        const state = link.participantExerciseState.toLowerCase();
        if (state === 'completed') return 'completed';
        if (state === 'rejected') return 'failed';
        if (state === 'awaitingconfirmation') return 'checking';
        if (state === 'created') return 'inProgress';
      }

      if (link.participantExercise && link.participantExercise.state) {
        const state = link.participantExercise.state.toLowerCase();
        if (state === 'completed') return 'completed';
        if (state === 'rejected') return 'failed';
        if (state === 'awaitingconfirmation') return 'checking';
        if (state === 'created') return 'inProgress';
      }

      if (link && link.state) {
        const state = link.state.toLowerCase();
        if (state === 'completed') return 'completed';
        if (state === 'rejected') return 'failed';
        if (state === 'awaitingconfirmation') return 'checking';
        if (state === 'created') return 'inProgress';
      }

      return 'available';
    },

    getLinkStatusClass(link) {
      const state = this.getLinkState(link);
      return `task--chain--${state}`;
    },

    getLinkDisciplines(link) {
      if (link.exercise) {
        return link.exercise.disciplines || [];
      }
      if (link.exerciseChainLink && link.exerciseChainLink.exercise) {
        return link.exerciseChainLink.exercise.disciplines || [];
      }
      return [];
    },

    getLinkImage(link) {
      if (link.exercise && link.exercise.images) {
        return link.exercise.images.mobile || '';
      }
      if (link.exerciseChainLink && link.exerciseChainLink.exercise && link.exerciseChainLink.exercise.images) {
        return link.exerciseChainLink.exercise.images.mobile || '';
      }
      return '';
    },

    getLinkItemsTotal(link) {
      if (link.countTasksTotal !== undefined) {
        return link.countTasksTotal;
      }
      if (link.participantExercise && link.participantExercise.countTasksTotal !== undefined) {
        return link.participantExercise.countTasksTotal;
      }
      return 0;
    },

    getLinkItemsDone(link) {
      // Приоритетно берем из новой структуры
      if (link.countTasksCompleted !== undefined) {
        return link.countTasksCompleted;
      }
      // Fallback на старую структуру participantExercise
      if (link.participantExercise && link.participantExercise.countTasksCompleted !== undefined) {
        return link.participantExercise.countTasksCompleted;
      }
      return 0;
    },

    getLinkChainsCount(link) {
      if (link && link.countTasksTotal !== undefined) {
        return link.countTasksTotal;
      }
      return 0;
    },

    getLinkEndDate(link) {
      // Сначала проверяем endDate в самом линке
      if (link && link.endDate) {
        return link.endDate;
      }

      // Затем проверяем в exercise
      if (link.exercise && link.exercise.endDate) {
        return link.exercise.endDate;
      }

      // Затем проверяем в exerciseChainLink.exercise
      if (link.exerciseChainLink && link.exerciseChainLink.exercise && link.exerciseChainLink.exercise.endDate) {
        return link.exerciseChainLink.exercise.endDate;
      }

      // Если нет, используем общую дату окончания цепочки
      if (this.data && this.data.participantExerciseChain && this.data.participantExerciseChain.endDate) {
        return this.data.participantExerciseChain.endDate;
      }

      if (this.data && this.data.endDate) {
        return this.data.endDate;
      }

      return '';
    },

    getTaskRewardRange(link) {
      let exercise = null;

      if (link.exercise) {
        exercise = link.exercise;
      } else if (link.exerciseChainLink && link.exerciseChainLink.exercise) {
        exercise = link.exerciseChainLink.exercise;
      }

      if (!exercise) return '';

      const reward = exercise.reward || 0;
      const maxReward = exercise.maxReward || 0;

      if (maxReward && reward < maxReward) {
        return `${Math.round(reward)}-${maxReward}`;
      }
      return Math.round(reward);
    },

    filterDisciplines(arr) {
      if (!Array.isArray(arr)) return [];

      const specialDisciplines = [
        'survey',
        'fitness',
        'strength',
        'martialarts',
        'playing',
        'extreme',
        'outdoor',
        'dancing',
      ];

      // Приводим к нижнему регистру
      const lowerArr = arr
        .map((d) => (d && typeof d === 'string' ? d.toLowerCase() : d));

      const result = [];
      let hasHeart = false;

      lowerArr.forEach((d) => {
        if (specialDisciplines.includes(d)) {
          hasHeart = true;
        } else if (this.disciplineCodes.includes(d) && !result.includes(d)) {
          result.push(d);
        }
      });

      if (hasHeart) {
        result.unshift('heart');
      }

      return result;
    },

    getDisciplines() {
      const disciplines = [];
      let steps = [];

      // Определяем, откуда брать steps в зависимости от структуры данных
      if (this.data && this.data.participantExerciseChain && this.data.participantExerciseChain.links) {
        // Вкладка 1 или 2 - данные участника
        steps = this.data.participantExerciseChain.links;
      } else if (this.data && this.data.links) {
        // Вкладка 0 - общие данные цепочки
        steps = this.data.links;
      }

      const uniqueDisciplineSet = new Set();
      if (!steps) return [];

      if (!Array.isArray(this.disciplineCodes)) {
        return disciplines;
      }

      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < steps.length; i++) {
        const step = steps[i];
        let exercise = null;

        if (step.exercise) {
          exercise = step.exercise;
        } else if (step.exerciseChainLink && step.exerciseChainLink.exercise) {
          exercise = step.exerciseChainLink.exercise;
        }

        if (!exercise) continue;

        const discipline = exercise.disciplines || null;
        if (!discipline) continue;

        const disciplineArr = Array.isArray(discipline) ? discipline : [discipline];

        // eslint-disable-next-line no-restricted-syntax
        for (const d of disciplineArr) {
          if (!d) continue;
          const dLower = d.toLowerCase();
          if (uniqueDisciplineSet.has(dLower)) continue;
          uniqueDisciplineSet.add(dLower);

          if (this.disciplineCodes.includes(dLower)) {
            if (dLower === 'survey') {
              if (!disciplines.includes('quiz')) {
                disciplines.push('quiz');
              }
            } else if (
              ['strength', 'martialarts', 'playing', 'extreme', 'outdoor', 'dancing', 'fitness'].includes(dLower)
            ) {
              if (!disciplines.includes('heart')) {
                disciplines.push('heart');
              }
            } else {
              disciplines.push(dLower);
            }
          }
        }
      }

      return disciplines;
    },

    getComplexityClass() {
      const task = this.data;
      if (!task) return '';
      if (task.complexity <= 1.3) {
        return 'reward-card__complexity_low';
      } if (task.complexity <= 1.8) {
        return 'reward-card__complexity_medium';
      } if (task.complexity <= 2.4) {
        return 'reward-card__complexity_high';
      }
      return 'reward-card__complexity_master';
    },

    getTaskComplexity() {
      const task = this.data;
      if (!task) return '';
      if (task.complexity <= 1.3) {
        return 'Новичок';
      } if (task.complexity <= 1.8) {
        return 'Любитель';
      } if (task.complexity <= 2.4) {
        return 'Опытный';
      }
      return 'Мастер';
    },

    getTaskReward() {
      if (!this.data) return 0;
      const chainReward = this.data.reward !== undefined && this.data.reward !== null ? Number(this.data.reward) : NaN;
      const chainMaxReward = this.data.maxReward !== undefined && this.data.maxReward !== null ? Number(this.data.maxReward) : NaN;
      const hasChainReward = Number.isFinite(chainReward) && chainReward > 0;
      if (hasChainReward) {
        const maxReward = Number.isFinite(chainMaxReward) && chainMaxReward > 0 ? chainMaxReward : chainReward;
        return chainReward < maxReward ? `${Math.round(chainReward)}-${maxReward}` : Math.round(chainReward);
      }
      // Иначе — сумма из звеньев цепочки (как до новой схемы)
      let reward = 0;
      let maxReward = 0;
      const list = this.links || [];
      for (let i = 0; i < list.length; i += 1) {
        const link = list[i];
        const ex = link.exercise || (link.exerciseChainLink && link.exerciseChainLink.exercise);
        if (ex) {
          reward += ex.reward || 0;
          maxReward += ex.maxReward || 0;
        }
      }
      return maxReward && reward < maxReward ? `${Math.round(reward)}-${maxReward}` : Math.round(reward);
    },

    getCompletedReward() {
      if (!this.data) return 0;
      if (!this.data.participantExerciseChain) return this.getTaskReward();
      if (this.data.participantExerciseChain.state === 'Completed') {
        const completedReward = this.data.participantExerciseChain.reward;
        const hasReward = completedReward !== undefined && completedReward !== null && Number(completedReward) > 0;
        return hasReward ? Math.round(Number(completedReward)) : this.getTaskReward();
      }
      return this.getTaskReward();
    },

    getTaskRatingPoints() {
      if (!this.data) return 0;
      const rating = this.rating || {};
      const minRatingPoints = Math.round(rating.minRatingPoints || 0);
      const maxRatingPoints = Math.round(rating.maxRatingPoints || 0);
      return minRatingPoints === maxRatingPoints ? `${minRatingPoints}` : `${minRatingPoints}+`;
    },
    hasRatingPoints() {
      const rating = this.rating || {};
      const min = Math.round(rating.minRatingPoints || 0);
      const max = Math.round(rating.maxRatingPoints || 0);
      return min > 0 || max > 0;
    },

    getCompletedTaskState() {
      if (!this.data || !this.data.participantExerciseChain) return '';
      const { state } = this.data.participantExerciseChain;
      if (state === 'Completed') return 'completed';
      if (state === 'Rejected') return 'failed';
      if (state === 'AwaitingConfirmation') return 'checking';
      return '';
    },

    getBadgeText() {
      if (this.currentState === 'inProgress' && this.data) {
        const { countLinksCompleted, countLinksTotal } = this.data.participantExerciseChain;
        if (countLinksTotal > 0) {
          return `${countLinksCompleted}/${countLinksTotal}`;
        }
      }
      return '';
    },

    getFormattedDate() {
      if (!this.data) return '';
      let date = this.data.endDate;
      if (this.isCompletedChain()) {
        if (this.data.participantExerciseChain) {
          if (this.data.participantExerciseChain.state === 'Completed' && this.data.participantExerciseChain.completedOn) {
            date = this.data.participantExerciseChain.completedOn;
          } else if (this.data.participantExerciseChain.state === 'Rejected' && this.data.participantExerciseChain.rejectedOn) {
            date = this.data.participantExerciseChain.rejectedOn;
          }
        }
      }
      const value = dayjs.utc(date);
      if (value.isValid()) {
        return value.format('DD.MM.YYYY');
      }
      return '';
    },

    getCompletedTaskDate() {
      const task = this.data;
      if (!task || !task.participantExerciseChain) return '';
      let date = '';
      if (task.participantExerciseChain.state === 'Completed' && task.participantExerciseChain.completedOn) {
        date = task.participantExerciseChain.completedOn;
      } else if (task.participantExerciseChain.state === 'Rejected' && task.participantExerciseChain.rejectedOn) {
        date = task.participantExerciseChain.rejectedOn;
      }
      if (date) {
        const value = dayjs.utc(date);
        if (value.isValid()) {
          return value.format('DD.MM.YYYY');
        }
      }
      return '';
    },
    isCompletedChain() {
      return this.currentState === 'completed' || this.currentState === 'failed';
    },

    startCountdown() {
      let endDate = '';

      // Сначала проверяем endDate в participantExerciseChain
      if (this.data && this.data.participantExerciseChain && this.data.participantExerciseChain.endDate) {
        endDate = this.data.participantExerciseChain.endDate;
      } else if (this.data && this.data.endDate) {
        // Затем проверяем endDate в корне данных
        endDate = this.data.endDate;
      } else if (this.links && this.links.length > 0 && this.links[0].endDate) {
        // Если нет, ищем в первом линке
        endDate = this.links[0].endDate;
      }

      if (endDate) {
        this.setCountdown(endDate);
      } else {
        this.countdownText = '00:00:00';
      }
    },

    setCountdown(date) {
      const value = dayjs.utc(date);
      if (value.isValid()) {
        this.dateValue = value;
        this.updateCountdown();
      } else {
        this.countdownText = '00:00:00';
      }
    },

    updateCountdown() {
      try {
        if (!this.dateValue) {
          this.countdownText = '00:00:00';
          return;
        }

        const seconds = this.dateValue.diff(dayjs.utc(), 'seconds');

        if (seconds <= 0) {
          this.countdownText = '00:00:00';
          // Если время истекло, обновляем состояние
          if (this.currentState === 'inProgress') {
            this.currentState = 'failed';
          }
          return;
        }

        this.countdownText = this.formatCountdown(seconds);

        // Запускаем следующее обновление
        this.countdownTimer = setTimeout(() => {
          this.updateCountdown();
        }, this.isLongCountDown ? 60000 : 1000);
      } catch (error) {
        console.error('Ошибка в updateCountdown:', error);
        this.countdownText = '00:00:00';
      }
    },

    formatCountdown(seconds) {
      const duration = dayjs.duration(seconds * 1000);
      const days = Math.floor(duration.asDays());
      const hours = duration.hours();
      if (days >= 1) {
        this.isLongCountDown = true;
        return `${days}д ${hours}ч`;
      }
      this.isLongCountDown = false;
      return duration.format('HH:mm:ss');
    },

    clearCountdown() {
      if (this.countdownTimer) {
        clearTimeout(this.countdownTimer);
        this.countdownTimer = null;
      }
      this.countdownText = '';
      this.dateValue = null;
      this.isLongCountDown = false;
    },

    onConfirmTaskCancel() {
      this.cancelError = '';
      this.cancellingTask = false;
      this.taskCancelModal = true;
    },

    onCancelTask() {
      this.cancelError = '';
      this.cancellingTask = true;

      // Проверяем существование данных
      if (!this.data || !this.data.participantExerciseChain) {
        this.cancelError = 'Ошибка: данные цепочки не найдены';
        this.cancellingTask = false;
        return;
      }

      const { participantExerciseChainId } = this.data.participantExerciseChain;

      if (!participantExerciseChainId) {
        this.cancelError = 'Ошибка: ID цепочки не найден';
        this.cancellingTask = false;
        return;
      }

      this.cancelTaskChain({ participantExerciseChainId })
        .then(() => {
          if (this.cancelStatus === 204) {
            // Сбрасываем флаг загрузки и закрываем модальное окно отмены
            this.cancellingTask = false;
            this.taskCancelModal = false;
            // Эмитим событие для обновления данных вместо перезагрузки страницы
            this.$emit('chainCancelled');
            this.$emit('close');
            return;
          }
          this.cancelError = `Произошла ошибка: ${this.cancelStatus}`;
          this.cancellingTask = false;
        })
        .catch((error) => {
          console.error('Ошибка при отмене цепочки:', error);
          this.cancelError = 'Произошла ошибка при отмене цепочки';
          this.cancellingTask = false;
        });
    },

    onSupport() {
      // Метод для поддержки - можно добавить логику позже
    },

    openActiveChain() {
      if (this.hasActiveChain && this.data.activeParticipantChainInfo) {
        const { participantExerciseChainId } = this.data.activeParticipantChainInfo;
        // Эмитим событие для открытия активной цепочки
        this.$emit('openActiveChain', { participantExerciseChainId });
      }
    },

    getLinkAction(link, index) {
      // Если звено только для цепочки - не показываем действие
      if (link.isChainOnly === true) {
        return null;
      }

      // Если звено неактивно - показываем действие для открытия обычного задания
      if (link.linkState === 'InActive') {
        return { func: () => this.onShowInactiveChainTask(index) };
      }

      // Для активных звеньев (InProgress, Completed) - показываем действие для связанного с пользователем задания
      return { func: () => this.onShowChainTask(index) };
    },

    onShowInactiveChainTask(index) {
      const link = this.links[index];

      if (!link) {
        return;
      }

      let exerciseId = null;

      // Определяем ID задания в зависимости от структуры данных
      if (link.exercise && link.exercise.exerciseId) {
        // Вкладка 0 - прямая структура
        exerciseId = link.exercise.exerciseId;
      } else if (link.exerciseChainLink && link.exerciseChainLink.exercise && link.exerciseChainLink.exercise.exerciseId) {
        // Вкладка 1 или 2 - вложенная структура
        exerciseId = link.exerciseChainLink.exercise.exerciseId;
      }

      // Для неактивных звеньев эмитим событие с только exerciseId (без participantExerciseId)
      this.$emit('showChainTask', {
        exerciseId,
        participantExerciseId: null,
      });
    },

    onShowChainTask(index) {
      const link = this.links[index];

      if (!link) {
        return;
      }

      if (link.isChainOnly === true) {
        return;
      }

      let exerciseId = null;
      let participantExerciseId = null;

      // Определяем ID задания в зависимости от структуры данных
      if (link.exercise && link.exercise.exerciseId) {
        // Вкладка 0 - прямая структура
        exerciseId = link.exercise.exerciseId;
      } else if (link.exerciseChainLink && link.exerciseChainLink.exercise && link.exerciseChainLink.exercise.exerciseId) {
        // Вкладка 1 или 2 - вложенная структура
        exerciseId = link.exerciseChainLink.exercise.exerciseId;
      }

      // Приоритетно ищем participantExerciseId для открытия информации о задании
      if (link.participantExerciseId) {
        // Прямой participantExerciseId
        participantExerciseId = link.participantExerciseId;
      } else if (link.participantExercise && link.participantExercise.participantExerciseId) {
        // Вложенный participantExerciseId
        participantExerciseId = link.participantExercise.participantExerciseId;
      } else if (link.participantExerciseChainLinkId) {
        // Используем participantExerciseChainLinkId как fallback
        participantExerciseId = link.participantExerciseChainLinkId;
      }

      this.$emit('showChainTask', {
        exerciseId,
        participantExerciseId,
      });
    },

    toggleDescription() {
      this.showFullDescription = !this.showFullDescription;
    },
  },
  mounted() {
    // Если дата уже есть при маунте
    if (this.data && this.active) {
      this.startCountdown();
    }
  },
  beforeDestroy() {
    // Очищаем таймер при уничтожении компонента
    this.clearCountdown();
  },
};
</script>

<style lang="scss" scoped>
@import '../TaskDetailsModal/TaskDetailsModal';
@import './ChainTaskDetailsModal';
</style>
